module.exports = __webpack_public_path__ + "img/line.5edd5d3a.svg";